class ProductListing {
    constructor() {
        this.allProducts = [];
        this.currentPage = 1;
        this.itemsPerPage = 12;
        this.filters = {
            finish: [],
            filter_collection: [],
            by_style: [],
            by_material: [],
            _filter_application: [],
            by_use_or_room: [],
            backplate: [],
            lever_style: [],
            category: [],
            length: [],
            filter_by_size_or_strength: [],
        };
        this.availableFilters = {
            finish: [],
            filter_collection: [],
            by_style: [],
            by_material: [],
            _filter_application: [],
            by_use_or_room: [],
            backplate: [],
            lever_style: [],
            category: [],
            length: [],
            filter_by_size_or_strength: [],
        };

        this.filterTypes = [
            { key: "finish", label: "FINISH" },
            { key: "lever_style", label: "LEVER STYLE" },
            { key: "backplate", label: "ROSE AND BACKPLATE SHAPE" },
            { key: "by_style", label: "STYLE" },
            { key: "category", label: "SHOP BY CATEGORY" },
            { key: "filter_collection", label: "SHOP BY COLLECTION" },
            { key: "by_use_or_room", label: "ROOM" },
            { key: "length", label: "LENGTH" },
            { key: "filter_by_size_or_strength", label: "SIZE OR STRENGTH" },
            { key: "_filter_application", label: "APPLICATION" },
        ];

        // Curated "Shop by Category" list — must mirror the header mega-menu exactly.
        // Any other Shopify collection a product belongs to (sub-collections, merchandising
        // collections, etc.) is deliberately excluded from this filter.
        this.ALLOWED_CATEGORY_TITLES = new Set([
            "handles on roses",
            "handles on long plates",
            "entrance handles",
            "sliding blade pulls",
            "sliding flush pulls",
            "door accessories",
            "locks, cylinders and latches",
            "escutcheons & turn snibs",
            "door closers",
            "door stops",
            "hinges",
            "cabinet handles",
            "bathware accessories",
            "spare parts",
        ].map(t => t.toLowerCase()));

        // Some Shopify collections have a real admin title that doesn't match the
        // "Shop by Category" label we want shown in the nav/filter (e.g. the collection
        // is titled "Door Handles" in Shopify but should read "Handles on Roses" here).
        // Matching by title alone silently drops these, so we match by handle instead
        // (handles are stable) and use this map to force the correct display label.
        // Keyed by collection handle -> desired display name.
        this.CATEGORY_HANDLE_OVERRIDES = new Map([
            ["door-handles", "Handles on Roses"],
            ["door-handles-on-long-backplates", "Handles on Long Plates"],
            ["entrance-pulls", "Entrance handles"],
        ]);

        // Fixed display order for the "SHOP BY CATEGORY" filter — must mirror the
        // header mega-menu's column order (read down the left column first, then
        // down the right column), not row-by-row. Matched case-insensitively
        // against the resolved display name (post CATEGORY_HANDLE_OVERRIDES), not
        // the raw Shopify collection title. Anything not listed here (shouldn't
        // happen given ALLOWED_CATEGORY_TITLES) is sorted alphabetically and
        // pushed to the end.
        this.CATEGORY_DISPLAY_ORDER = [
            // left column, top to bottom
            "handles on roses",
            "handles on long plates",
            "entrance handles",
            "sliding blade pulls",
            "sliding flush pulls",
            "door accessories",
            "locks, cylinders and latches",
            // right column, top to bottom
            "escutcheons & turn snibs",
            "door closers",
            "door stops",
            "hinges",
            "cabinet handles",
            "bathware accessories",
            "spare parts",
        ];

        this.sortOption = "manual";
        this.defaultOpenFilter = "";
        this.loading = false;
        this.isFetching = false;
        this.error = null;

        this.STOREFRONT_ACCESS_TOKEN = "fe897ac638c3b4bbece4814d25e20187";
        this.SHOPIFY_STORE_DOMAIN = "designer-doorware-au.myshopify.com";
        this.API_VERSION = "2025-01";
        this.COLLECTION_HANDLE = typeof current_collection !== 'undefined' ? current_collection : 'all';
        this.MAX_PRODUCTS_PER_QUERY = 250;
        this.PLACEHOLDER_IMAGE = document.getElementById("product_card_placeholder")?.value || "";
        this.CURRENCY_SYMBOL = document.getElementById("currency_symbol")?.value || "$";

        const urlParams = new URLSearchParams(window.location.search);
        this.sortOption = urlParams.get("sort_by") || "manual";
        this.currentPage = parseInt(urlParams.get("page")) || 1;
        Object.keys(this.filters).forEach((key) => {
            const values = urlParams.getAll(key);
            if (values.length > 0) this.filters[key] = values;
        });

        this.init();
    }

    init() {
        console.log('custom-product-listing');
        this.bindEventListeners();
        this.fetchAllProducts();
    }

    bindEventListeners() {
        document.addEventListener("toggle", function (e) {
            const detailsEl = e.target;
            if (detailsEl && detailsEl.tagName === 'DETAILS' && detailsEl.classList.contains('js-filter') && detailsEl.open) {
                const detailsElements = document.querySelectorAll("details.js-filter");
                detailsElements.forEach((otherEl) => {
                    if (otherEl !== detailsEl && otherEl.open) {
                        otherEl.removeAttribute("open");
                    }
                });
                setTimeout(() => {
                    const offset = 120;
                    const elementPosition = detailsEl.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }, 50);
            }
        }, true);
        document.getElementById("pagination").addEventListener("click", (e) => {
            const page = e.target.dataset.page;
            if (page === "next" && this.hasNextPage()) {
                this.currentPage++;
                this.updateURL();
                this.render().then(() => this.scrollToTop());
            } else if (page === "prev" && this.hasPreviousPage()) {
                this.currentPage--;
                this.updateURL();
                this.render().then(() => this.scrollToTop());
            } else if (page && !isNaN(page)) {
                this.currentPage = parseInt(page);
                this.updateURL();
                this.render().then(() => this.scrollToTop());
            }
        });

        document.getElementById("filter-section").addEventListener("change", (e) => {
            if (e.target.type === "checkbox") {
                const filterType = e.target.name;
                const value = e.target.value;
                const parentDetails = e.target.closest("details");
                this.filters[filterType] = e.target.checked
                    ? [...this.filters[filterType], value]
                    : this.filters[filterType].filter((v) => v !== value);
                this.currentPage = 1;
                this.defaultOpenFilter = parentDetails ? parentDetails.getAttribute("id") : "";
                this.updateURL();
                this.render().then(() => this.scrollToTop());
            }
        });

        document.querySelector(".mobile_facet_submit")?.addEventListener("click", () => {
            const checkboxes = document.querySelectorAll('#FacetFiltersFormMobile input[type="checkbox"]:checked');
            const newFilters = {};

            checkboxes.forEach((checkbox) => {
                const filterType = checkbox.name;
                const value = checkbox.value;
                newFilters[filterType] = newFilters[filterType] ? [...newFilters[filterType], value] : [value];
            });

            this.filters = { ...this.filters, ...newFilters };
            Object.keys(this.filters).forEach((key) => {
                if (!newFilters[key]) {
                    this.filters[key] = [];
                }
            });

            const CloseButton = document.querySelector(".mobile-facets__close");
            if (CloseButton) {
                CloseButton.click();
            }
            this.currentPage = 1;
            this.updateURL();
            this.render().then(() => this.scrollToTop());
        });

        document.getElementById("sort-section").addEventListener("change", (e) => {
            if (e.target.id === "sort-select") {
                this.sortOption = e.target.value;
                this.currentPage = 1;
                this.updateURL();
                this.render().then(() => this.scrollToTop());
            }
        });

        document.getElementById("FacetsWrapperMobile").addEventListener("change", (e) => {
            if (e.target.id === "sort-select-mobile") {
                this.sortOption = e.target.value;
                this.currentPage = 1;
                const CloseButton = document.querySelector(".mobile-facets__close");
                if (CloseButton) {
                    CloseButton.click();
                }

                this.updateURL();
                this.render().then(() => this.scrollToTop());
            }
        });

        document.getElementById("selected-filters").addEventListener("click", (e) => {
            const clearFilterButton = e.target.closest(".clear-filter");
            if (clearFilterButton) {
                const [filterType, value] = clearFilterButton.dataset.filter.split(":");
                this.filters[filterType] = this.filters[filterType].filter((v) => v !== value);
                this.currentPage = 1;
                this.updateURL();
                this.render().then(() => this.scrollToTop());
            } else if (e.target.id === "clear-all-filters") {
                Object.keys(this.filters).forEach((key) => (this.filters[key] = []));
                this.currentPage = 1;
                this.updateURL();
                this.render().then(() => this.scrollToTop());
            }
        });

        document.getElementById("filter-section").addEventListener("click", (e) => {
            const showMoreButton = e.target.closest(".button-show-more");
            if (showMoreButton) {
                const details = showMoreButton.closest("details");
                if (details) {
                    const showMoreItems = details.querySelectorAll(".show-more-item");
                    showMoreItems.forEach((item) => item.classList.toggle("hidden"));
                    showMoreButton.querySelector(".label-show-more").classList.toggle("hidden");
                    showMoreButton.querySelector(".label-show-less").classList.toggle("hidden");
                    details.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }

        });

        document.getElementById("product-grid").addEventListener("change", (e) => {
            if (e.target.classList.contains("swatch-input__input")) {
                const productCard = e.target.closest(".card_product_block");
                const addToCartButton = productCard.querySelector(".CustomAddToCartButton");
                this.updateAddToCartButtonState(productCard, addToCartButton);
            }
        });

        document.getElementById("product-grid").addEventListener("click", (e) => {
            const addToCartButton = e.target.closest(".CustomAddToCartButton");
            if (addToCartButton) {
                const collection_cart_form = document.getElementById("collection_cart_form");
                const productCard = addToCartButton.closest(".card_product_block");
                if (collection_cart_form) {
                    this.loading = true;
                    this.renderLoading();
                    const productID = addToCartButton.dataset.productid;
                    const variantID = addToCartButton.dataset.variantid;
                    const qty = productCard.querySelector('[name="quantity"]').value;
                    collection_cart_form.querySelector('[name="id"]').value = variantID;
                    collection_cart_form.querySelector('[name="quantity"]').value = qty;
                    collection_cart_form.querySelector('[name="product-id"]').value = productID;
                    collection_cart_form.querySelector('[name="add"]').click();
                    this.loading = false;
                    this.renderLoading();
                } else {
                    alert("Please select a finish and backplate before adding to cart.");
                }
            }
        });

        document.getElementById("FacetsWrapperMobile").addEventListener("click", (e) => {
            const summary = e.target.closest(".mobile-facets__summary");
            if (summary) {
                summary.parentElement.classList.toggle("menu-opening");
                const mobileFilterWrapper = document.getElementById("FacetsWrapperMobile");
                if (mobileFilterWrapper) {
                    mobileFilterWrapper.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        });

        document.getElementById("FacetsWrapperMobile").addEventListener("click", (e) => {
            const closebutton = e.target.closest(".mobile-facets__close-button");
            if (closebutton) {
                const summary = closebutton.closest(".mobile-facets__details");
                if (summary) {
                    summary.classList.remove("menu-opening");
                    setTimeout(() => {
                        summary.removeAttribute("open");
                    }, 200);
                }
            }
        });
    }

    scrollToTop() {
        // A short setTimeout guarantees that Swiper initialization and 
        // browser layout calculations are completely settled before measuring.
        setTimeout(() => {
            const anchor = document.getElementById("ProductGridContainer") || document.getElementById("product-grid");
            if (!anchor) return;

            // Target the first row item specifically if available, fallback to the grid container
            const firstRowItem = anchor.querySelector('.grid__item') || anchor;

            // Dynamically calculate sticky header offsets
            const stickyHeader = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('.section-header');
            const headerHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;

            // Add a safety buffer (e.g., 20px) so the top row isn't flush against the header
            const offset = headerHeight + 20;

            // Calculate exact position relative to the document
            const elementPosition = firstRowItem.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: Math.max(offsetPosition, 0),
                behavior: 'smooth'
            });
        }, 100); // 100ms is standard to let Swiper and CSS transitions settle
    }

    makeHndle(str) {
        if (!str) return "";
        return str.trim().replaceAll("(", "").replaceAll(")", "").replaceAll(/[^a-z0-9]+/gi, "-").toLowerCase();
    }

    formatImageUrl(url, width) {
        if (!url) return this.PLACEHOLDER_IMAGE;
        if (url.includes('cloudfront.net')) return url;
        const connector = url.includes('?') ? '&' : '?';
        return `${url}${connector}width=${width}`;
    }

    isAllowedCategory(collection) {
        if (!collection || !collection.handle) return false;
        if (collection.handle === 'all') return false;
        // Handle-based override takes precedence — covers collections whose real
        // Shopify title doesn't match the desired "Shop by Category" label.
        if (this.CATEGORY_HANDLE_OVERRIDES.has(collection.handle)) return true;
        if (!collection.title) return false;
        return this.ALLOWED_CATEGORY_TITLES.has(collection.title.trim().toLowerCase());
    }

    // Resolves the display label to show in the "SHOP BY CATEGORY" filter for a
    // given collection — prefers the override name, falls back to the real title.
    getCategoryDisplayName(collection) {
        return this.CATEGORY_HANDLE_OVERRIDES.get(collection.handle) || collection.title || collection.handle;
    }

    // Sorts "SHOP BY CATEGORY" filter options to match the header mega-menu's
    // fixed reading order (CATEGORY_DISPLAY_ORDER) instead of alphabetically.
    // Anything not found in that list falls back to the end, alphabetically.
    sortByCategoryDisplayOrder(categories) {
        const order = this.CATEGORY_DISPLAY_ORDER;
        const indexOf = (name) => order.indexOf((name || "").trim().toLowerCase());
        return [...categories].sort((a, b) => {
            const ai = indexOf(a.name);
            const bi = indexOf(b.name);
            if (ai === -1 && bi === -1) return a.name.localeCompare(b.name);
            if (ai === -1) return 1;
            if (bi === -1) return -1;
            return ai - bi;
        });
    }

    async fetchAllProducts() {
        if (this.isFetching) return;
        this.isFetching = true;
        this.loading = true;
        this.error = null;
        this.renderLoading("Loading products...");

        try {
            console.log("Fetching products from Cloudflare cached JSON worker...");
            let cloudflareProducts;

            if (window.allCloudflareProducts && !window._cloudflareProductsPromise && !window.__cloudflareProductsPromise) {
                cloudflareProducts = window.allCloudflareRawProducts || window.allCloudflareProducts;
            }
            var country = (typeof country_code !== 'undefined' && country_code ? country_code : (window.shopify_country_code || (window.localization && window.localization.country && window.localization.country.iso_code) || 'AU')).toUpperCase();
            if (!cloudflareProducts) {
                var existingPromise = window._cloudflareProductsPromise || window.__cloudflareProductsPromise || window.__cloudflareProductsSearchPromise;
                if (!existingPromise) {
                    var promise = fetch(`${window.worker_base_url}/api/custom/collections-all.json?country=${country}`)
                        .then(res => {
                            if (!res.ok) throw new Error('HTTP ' + res.status);
                            return res.json();
                        })
                        .then(data => {
                            window.allCloudflareRawProducts = data;
                            if (!window.allCloudflareProducts) {
                                window.allCloudflareProducts = data;
                            }
                            return data;
                        })
                        .catch(err => {
                            window._cloudflareProductsPromise = null;
                            window.__cloudflareProductsPromise = null;
                            window.__cloudflareProductsSearchPromise = null;
                            throw err;
                        });
                    window._cloudflareProductsPromise = promise;
                    window.__cloudflareProductsPromise = promise;
                    window.__cloudflareProductsSearchPromise = promise;
                    existingPromise = promise;
                }
                cloudflareProducts = await existingPromise;
            }

            const rossets = new Set();
            const finishes = new Set();
            const collections = new Set();
            const styles = new Set();
            const materials = new Set();
            const applications = new Set();
            const useRooms = new Set();
            const category = new Set();
            const length = new Set();
            const sizeOrStrength = new Set();
            const productCode = new Set();





            // --- PHASE 1: COLLECT ALL FILTER DATA GLOBALLY ---
            cloudflareProducts.forEach((node) => {
                const safeHandle = (str) => str ? this.makeHndle(str) : "";
                const getName = (item) => item.name || item.style_name || item.material_name || item.category_name || item.title || (typeof item === 'string' ? item : "");

                const rawBackplates = node.backplates || node.rosset || [];
                const rawFinishes = node.finishes || node.finish || [];
                const rawRooms = node.rooms || node.by_use_or_room || [];

                rawBackplates.forEach(r => rossets.add(JSON.stringify({ id: safeHandle(getName(r)), name: getName(r), code: (r.code || "").replace(/^-+/, "") })));
                rawFinishes.forEach(f => finishes.add(JSON.stringify({ id: safeHandle(getName(f)), name: getName(f), code: f.code || "" })));
                (node.styles || []).forEach(s => styles.add(JSON.stringify({ id: safeHandle(getName(s)), name: getName(s) })));
                (node.materials || []).forEach(m => materials.add(JSON.stringify({ id: safeHandle(getName(m)), name: getName(m) })));
                (node.applications || []).forEach(a => applications.add(JSON.stringify({ id: safeHandle(getName(a)), name: getName(a) })));
                rawRooms.forEach(r => useRooms.add(JSON.stringify({ id: safeHandle(getName(r)), name: getName(r) })));
                (node.filter_collection || []).forEach(c => collections.add(JSON.stringify({ id: safeHandle(getName(c)), name: getName(c) })));
                (node.lengths || []).forEach(l => length.add(JSON.stringify({ id: safeHandle(getName(l)), name: getName(l) })));
                (node.sizes || []).forEach(s => sizeOrStrength.add(JSON.stringify({ id: safeHandle(getName(s)), name: getName(s) })));

                // Category filter now sources directly from the real Shopify collections
                // attached to each product (node.collections: {id, title, handle}) coming
                // from the /api/custom/collections-all.json worker response, instead of
                // guessing category names from tags/metafields.
                (node.collections || []).forEach(c => {
                    if (!this.isAllowedCategory(c)) return;
                    category.add(JSON.stringify({ id: c.handle, name: this.getCategoryDisplayName(c) }));
                });

                if (node.title) {
                    if ((node.tags || []).includes('Levers on Roses') || (node.tags || []).includes('Levers on Long Backplate')) {
                        productCode.add(JSON.stringify({
                            id: this.makeHndle(node.title),
                            name: node.title,
                        }));
                    }
                }

                if (node.category_swatches && node.category_swatches.length > 0) {
                    node.category_swatches.forEach(s => {
                        if (s.name) finishes.add(JSON.stringify({ id: safeHandle(s.name), name: s.name, code: s.code || "" }));
                    });
                }
            });

            // --- PHASE 2: PROCESS GRID DISPLAY ENTRIES ---
            const allProducts = cloudflareProducts.flatMap((node) => {
                if (this.COLLECTION_HANDLE && this.COLLECTION_HANDLE !== 'all') {
                    const belongsToCollection = node.collections && node.collections.includes(this.COLLECTION_HANDLE);
                    if (!belongsToCollection) return [];
                }

                const rawBackplates = node.backplates || node.rosset || [];
                const rawFinishes = node.finishes || node.finish || [];
                const rawRooms = node.rooms || node.by_use_or_room || [];

                const safeHandle = (str) => str ? this.makeHndle(str) : "";
                const getName = (item) => item.name || item.style_name || item.material_name || item.category_name || item.title || (typeof item === 'string' ? item : "");

                const finishValues = rawFinishes.map(f => ({ id: safeHandle(getName(f)), name: getName(f), color_code: f.color_code || "#ffffff", code: f.code || "" })).filter(v => v.id && v.name);
                const rossetValues = rawBackplates.map(r => ({ id: safeHandle(getName(r)), name: getName(r), code: (r.code || "").replace(/^-+/, "") })).filter(v => v.id && v.name);
                const styleValues = (node.styles || []).map(s => ({ id: safeHandle(getName(s)), name: getName(s) })).filter(v => v.id && v.name);
                const materialValues = (node.materials || []).map(m => ({ id: safeHandle(getName(m)), name: getName(m) })).filter(v => v.id && v.name);
                const applicationValues = (node.applications || []).map(a => ({ id: safeHandle(getName(a)), name: getName(a) })).filter(v => v.id && v.name);
                const useRoomValues = rawRooms.map(r => ({ id: safeHandle(getName(r)), name: getName(r) })).filter(v => v.id && v.name);
                const collectionValues = (node.filter_collection || []).map(c => ({ id: safeHandle(getName(c)), name: getName(c) })).filter(v => v.id && v.name);
                const lengthValues = (node.lengths || []).map(l => ({ id: safeHandle(getName(l)), name: getName(l) })).filter(v => v.id && v.name);
                const sizeValues = (node.sizes || []).map(s => ({ id: safeHandle(getName(s)), name: getName(s) })).filter(v => v.id && v.name);
                const functionValues = (node.functions || []).map(f => ({ id: safeHandle(getName(f)), name: getName(f), code: f.code || "" })).filter(v => v.id && v.name);

                // Map categories for this product's internal filtering reference, sourced
                // directly from its real Shopify collections (id/title/handle) so the
                // "SHOP BY CATEGORY" checkboxes match on the actual collection handle rather
                // than a guessed slug.
                const categoryValues = (node.collections || [])
                    .filter(c => this.isAllowedCategory(c))
                    .map(c => ({ id: c.handle, name: this.getCategoryDisplayName(c) }));

                const hasMetafield = node.category_skus_raw &&
                    node.category_skus_raw !== '[]' &&
                    node.category_skus_raw !== '""' &&
                    node.category_skus_raw !== 'null' &&
                    node.category_skus_raw.trim() !== '';

                let allowedSkus = [];
                if (hasMetafield) {
                    try {
                        let raw = node.category_skus_raw.replace(/[\[\]"]/g, '');
                        allowedSkus = raw.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
                    } catch (e) { }
                }

                const rawSwatchSource = node.category_swatches || [];
                const swatchSourceHandle = node.handle;
                const nodeHandle = node.handle;

                const swatchValues = rawSwatchSource.length > 0 ? rawSwatchSource.map(s => {
                    let sku = s.sku || "";
                    if (sku && sku.startsWith("-")) {
                        sku = swatchSourceHandle + sku;
                    }
                    let imageUrl = s.image_url || "";
                    if (imageUrl) {
                        const urlParts = imageUrl.split("/");
                        const lastPart = urlParts[urlParts.length - 1];
                        if (lastPart.startsWith("-")) {
                            urlParts[urlParts.length - 1] = swatchSourceHandle + lastPart;
                            imageUrl = urlParts.join("/");
                        }
                    }
                    return {
                        id: safeHandle(s.name),
                        name: s.name,
                        color_code: s.color_code || "#ffffff",
                        code: s.code || "",
                        sku: sku,
                        variant_id: s.variant_id || "",
                        variant_price: s.variant_price || s.price || "",
                        product_id: s.product_id || "",
                        product_handle: s.product_handle || "",
                        image_url: imageUrl
                    };
                }).filter(v => {
                    if (!v.id || !v.name || !v.sku) return false;
                    if (allowedSkus.length > 0) {
                        const checkSku = v.sku.toLowerCase().trim();
                        return allowedSkus.some(allowed => allowed === checkSku || checkSku.includes(allowed) || allowed.includes(checkSku));
                    }
                    return true;
                }) : [];

                if (allowedSkus.length > 0 && swatchValues.length > 0) {
                    swatchValues.sort((a, b) => {
                        const aSku = (a.sku || "").toLowerCase().trim().replace(/[\/\s+]/g, "");
                        const bSku = (b.sku || "").toLowerCase().trim().replace(/[\/\s+]/g, "");
                        const aIndex = allowedSkus.findIndex(allowed => {
                            const normAllowed = allowed.replace(/[\/\s+]/g, "");
                            return aSku === normAllowed || aSku.endsWith("-" + normAllowed) || normAllowed.endsWith("-" + aSku) || aSku.includes(normAllowed) || normAllowed.includes(aSku);
                        });
                        const bIndex = allowedSkus.findIndex(allowed => {
                            const normAllowed = allowed.replace(/[\/\s+]/g, "");
                            return bSku === normAllowed || bSku.endsWith("-" + normAllowed) || normAllowed.endsWith("-" + bSku) || bSku.includes(normAllowed) || normAllowed.includes(bSku);
                        });
                        return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
                    });
                }

                const baseId = node.id ? node.id.split("/").pop() : Math.random().toString(36).substr(2, 9);

                // Only expand into multiple cards if the worker explicitly set rosset_code
                // (i.e., select_variants is active on this product in Shopify).
                // Products that happen to have backplates metaobjects but no select_variants
                // should render as a single card.
                if (!node.rosset_code) {
                    return [{
                        id: baseId,
                        title: node.title,
                        handle: node.handle,
                        nodeHandle: nodeHandle,
                        sku_handle: this.makeHndle(node.product_code || node.handle),
                        images: node.images || [],
                        price: node.price || { minVariantPrice: { amount: "0.00", currencyCode: "AUD" } },
                        compareAtPriceRange: node.compareAtPriceRange || { minVariantPrice: { amount: "0.00", currencyCode: "AUD" } },
                        backplate_name: node.backplate_name,
                        backplate_id: null,
                        rosset_code: null,
                        finish: finishValues,
                        filter_collection: collectionValues,
                        by_style: styleValues,
                        by_material: materialValues,
                        _filter_application: applicationValues,
                        by_use_or_room: useRoomValues,
                        product_code: node.product_code,
                        variants: node.variants || [],
                        function: functionValues,
                        category: categoryValues,
                        length: lengthValues,
                        filter_by_size_or_strength: sizeValues,
                        backplate: rossetValues.length > 0
                            ? rossetValues.map(r => ({ id: r.id, name: r.name }))
                            : [{ id: null, name: null }],
                        lever_style: [{ id: node.title ? this.makeHndle(node.title) : "", name: node.title }],
                        category_swatches: swatchValues,
                        product_media: node.product_media || null,
                        collections: node.collections || [],
                        category_skus_raw: node.category_skus_raw || "",
                        allowed_skus: allowedSkus
                    }];
                }

                // Product with select_variants active — one card for this specific rosset prefix
                const thisRosset = rossetValues.find(r => r.code === node.rosset_code) || rossetValues[0];
                return [{
                    id: `${baseId}-${node.rosset_code}`,
                    title: node.title,
                    handle: node.handle,
                    nodeHandle: nodeHandle,
                    sku_handle: this.makeHndle(`${node.product_code || node.handle}-${node.rosset_code}`),
                    images: node.images || [],
                    price: node.price || { minVariantPrice: { amount: "0.00", currencyCode: "AUD" } },
                    compareAtPriceRange: node.compareAtPriceRange || { minVariantPrice: { amount: "0.00", currencyCode: "AUD" } },
                    backplate_name: node.backplate_name,
                    backplate_id: thisRosset ? this.makeHndle(thisRosset.name) : null,
                    rosset_code: node.rosset_code,
                    finish: finishValues,
                    filter_collection: collectionValues,
                    by_style: styleValues,
                    by_material: materialValues,
                    _filter_application: applicationValues,
                    by_use_or_room: useRoomValues,
                    product_code: node.product_code,
                    variants: node.variants || [],
                    function: functionValues,
                    category: categoryValues,
                    length: lengthValues,
                    filter_by_size_or_strength: sizeValues,
                    backplate: thisRosset ? [{ id: this.makeHndle(thisRosset.name), name: thisRosset.name }] : [{ id: null, name: null }],
                    lever_style: [{ id: node.title ? this.makeHndle(node.title) : "", name: node.title }],
                    category_swatches: swatchValues,
                    product_media: node.product_media || null,
                    collections: node.collections || [],
                    category_skus_raw: node.category_skus_raw || "",
                    allowed_skus: allowedSkus
                }];
            });

            const parseSet = (set) => {
                const seen = new Set();
                return [...set]
                    .filter((v) => v !== undefined && typeof v === "string")
                    .map((v) => {
                        try { return JSON.parse(v); } catch { return null; }
                    })
                    .filter((v) => {
                        if (!v || !v.id || !v.name) return false;
                        const key = v.id.toLowerCase();
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    });
            };

            this.availableFilters.backplate = parseSet(rossets);
            this.availableFilters.finish = parseSet(finishes);
            this.availableFilters.by_style = parseSet(styles);
            this.availableFilters.by_material = parseSet(materials);
            this.availableFilters._filter_application = parseSet(applications);
            this.availableFilters.by_use_or_room = parseSet(useRooms);
            this.availableFilters.filter_collection = parseSet(collections);
            this.availableFilters.category = this.sortByCategoryDisplayOrder(parseSet(category));
            this.availableFilters.length = parseSet(length).sort((a, b) => {
                const numA = parseFloat(a.name);
                const numB = parseFloat(b.name);
                if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
                if (!isNaN(numA)) return -1;
                if (!isNaN(numB)) return 1;
                return a.name.localeCompare(b.name);
            });
            this.availableFilters.filter_by_size_or_strength = parseSet(sizeOrStrength);
            this.availableFilters.lever_style = parseSet(productCode).sort((a, b) => a.name.localeCompare(b.name));

            this.allProducts = allProducts;
            window.allCloudflareProducts = allProducts;

            try {
                const skuSet = new Set();
                const addSku = (sku) => {
                    if (sku) skuSet.add(sku.replace(/[\/\s+]/g, '').toLowerCase().trim());
                };
                cloudflareProducts.forEach(node => {
                    (node.variants || []).forEach(v => addSku(v && v.sku));
                    (node.category_swatches || []).forEach(s => {
                        if (!s || !s.sku) return;
                        let sku = s.sku;
                        if (sku.startsWith('-')) sku = (node.handle || '') + sku;
                        addSku(sku);
                    });
                });
                window.allCloudflareSkus = skuSet;
            } catch (e) {
                window.allCloudflareSkus = new Set();
            }

            document.dispatchEvent(new CustomEvent('cloudflare-products-loaded'));
            this.render();
        } catch (error) {
            console.error("Error fetching products:", error);
            this.error = error.message;
        } finally {
            this.isFetching = false;
            this.loading = false;
            this.renderLoading();
        }
    }

    async fetchProductByHandle(handle) {
        const cache = window.allCloudflareProducts || this.allProducts || [];
        if (cache.length > 0) {
            let cached = cache.find(p => p.handle === handle || p.sku_handle === handle);
            if (!cached) {
                cached = cache.find(p => p.sku_handle && (handle.startsWith(p.sku_handle + "-") || handle === p.sku_handle));
            }
            if (cached) {
                return {
                    productId: cached.id.split("-")[0],
                    variantId: cached.variants?.[0]?.id || null,
                    availableForSale: true,
                    priceRange: cached.price,
                    compareAtPriceRange: cached.compareAtPriceRange,
                };
            }
        }
        return null;
    }

    async updateAddToCartButtonState(productCard, addToCartButton) {
        if (!productCard || !addToCartButton) {
            return;
        }

        const selectedFinishInput = productCard.querySelector(
            ".swatch-input__input:checked"
        );

        // No swatch selected
        if (!selectedFinishInput) {
            addToCartButton.disabled = true;

            addToCartButton.querySelector("span").textContent =
                "Out of Stock";

            return;
        }

        const variantId =
            selectedFinishInput.getAttribute("data-variant-id");

        const variantPrice =
            selectedFinishInput.getAttribute("data-variant-price");

        const productId =
            selectedFinishInput.getAttribute("data-product-id");

        const finishCode = selectedFinishInput.value;

        // VALID PRODUCT
        if (
            variantId &&
            variantId !== "null" &&
            variantId !== ""
        ) {
            addToCartButton.dataset.variantid =
                variantId.toString().split("/").pop();

            if (productId) {
                addToCartButton.dataset.productid =
                    productId.toString().split("/").pop();
            }

            addToCartButton.disabled = false;

            addToCartButton.classList.remove("disabled");

            addToCartButton.querySelector("span").textContent =
                "Add to Cart";
        }

        // OUT OF STOCK / INVALID
        else {
            addToCartButton.disabled = true;

            addToCartButton.classList.add("disabled");

            addToCartButton.removeAttribute("data-variantid");

            addToCartButton.removeAttribute("data-productid");

            addToCartButton.querySelector("span").textContent =
                "Out of Stock";
        }

        // UPDATE PRICE
        const priceSelector =
            productCard.querySelector(".sp_price_wrapper");

        if (priceSelector && variantPrice) {
            const currencyCode = window.Shopify?.currency?.active || "AUD";
            priceSelector.innerHTML = `
      <div class="price price--large">
        <div class="price__container">
          <div class="price__regular">
            <span class="price-item price-item--regular">
              ${this.CURRENCY_SYMBOL}${variantPrice} ${currencyCode}
            </span>
          </div>
        </div>
      </div>
    `;
        }

        // UPDATE PRODUCT URL
        const sku =
            selectedFinishInput.getAttribute("data-sku");

        const productURL =
            productCard.querySelectorAll(".update_url");

        if (productURL) {
            productURL.forEach((el) => {
                try {
                    const url = new URL(
                        el.href,
                        window.location.origin
                    );

                    const params = new URLSearchParams(url.search);

                    if (sku) {
                        params.set("sku", sku);

                        params.delete("auto");
                        params.delete("backplate");
                        params.delete("function");
                        params.delete("finish");
                        params.delete("timber-finish");
                    } else {
                        const fCodeToSet = finishCode
                            ? finishCode.startsWith("-")
                                ? finishCode
                                : `-${finishCode}`
                            : "";

                        params.set("finish", fCodeToSet);
                    }

                    url.search = params.toString();

                    el.setAttribute("href", url.toString());
                } catch (e) { }
            });
        }
    }

    updateURL() {
        const params = new URLSearchParams();
        if (this.sortOption !== "manual") params.set("sort_by", this.sortOption);
        if (this.currentPage > 1) params.set("page", this.currentPage);
        Object.entries(this.filters).forEach(([key, values]) => {
            if (values.length > 0) {
                values.forEach((value) => params.append(key, value));
            }
        });
        const queryString = params.toString();
        const newURL = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
        window.history.pushState({}, "", newURL);
    }

    getProductPrice(product) {
        if (!product) return 0;

        if (product.category_swatches && product.category_swatches.length > 0) {
            const firstSwatch = product.category_swatches[0];
            let price = parseFloat(firstSwatch.variant_price || firstSwatch.price);

            if (product.variants && product.variants.length > 0 && firstSwatch.sku) {
                const normSwatchSku = firstSwatch.sku.toLowerCase().trim().replace(/[\/\s+]/g, "");
                const foundVariant = product.variants.find((v) => {
                    if (!v || !v.sku) return false;
                    const normVSku = v.sku.toLowerCase().trim().replace(/[\/\s+]/g, "");
                    return normVSku === normSwatchSku;
                });
                if (foundVariant && foundVariant.price) {
                    const amt = parseFloat(foundVariant.price.amount || foundVariant.price);
                    if (!isNaN(amt) && amt > 0) price = amt;
                }
            }

            if (!isNaN(price) && price > 0) return price;
        }

        if (product.allowed_skus && product.allowed_skus.length > 0) {
            const firstSku = product.allowed_skus[0].replace(/[\/\s+]/g, "");

            if (product.variants && product.variants.length > 0) {
                const foundVariant = product.variants.find((v) => {
                    if (!v || !v.sku) return false;
                    const normVSku = v.sku.toLowerCase().trim().replace(/[\/\s+]/g, "");
                    return normVSku === firstSku || normVSku.endsWith("-" + firstSku) || firstSku.endsWith("-" + normVSku);
                });
                if (foundVariant && foundVariant.price) {
                    const amt = parseFloat(foundVariant.price.amount || foundVariant.price);
                    if (!isNaN(amt) && amt > 0) return amt;
                }
            }
        }

        const minPrice = parseFloat(product.price?.minVariantPrice?.amount || 0);
        if (!isNaN(minPrice) && minPrice > 0) return minPrice;

        if (product.variants && product.variants.length > 0) {
            const variantPrices = product.variants
                .map((v) => parseFloat(v.price?.amount || v.price))
                .filter((p) => !isNaN(p) && p > 0);
            if (variantPrices.length) return Math.min(...variantPrices);
        }

        return 0;
    }

    sortProducts(products) {
        const sorted = [...products];
        switch (this.sortOption) {
            case "price-asc":
                return sorted.sort(
                    (a, b) => this.getProductPrice(a) - this.getProductPrice(b)
                );
            case "price-desc":
                return sorted.sort(
                    (a, b) => this.getProductPrice(b) - this.getProductPrice(a)
                );
            case "title-asc":
                return sorted.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
            case "title-desc":
                return sorted.sort((a, b) => (b.title || "").localeCompare(a.title || ""));
            case "best-sellers":
                return sorted.filter((a) => (a.collections || []).includes("best-sellers"));
            case "new":
                return sorted.filter((a) => (a.collections || []).includes("new"));
            case "featured":
                return sorted.filter((a) => (a.collections || []).includes("featured"));
            case "manual":
                return sorted;
            default:
                return sorted;
        }
    }

    applyFilters(products) {
        return products.filter((product) => {
            return Object.entries(this.filters).every(
                ([filterType, selectedGids]) => {
                    if (selectedGids.length === 0) return true;
                    const productValues = product[filterType] || [];
                    return selectedGids.some((gid) =>
                        productValues.some((v) => v.id === gid)
                    );
                }
            );
        });
    }

    getFilteredAndSortedProducts() {
        const filteredProducts = this.applyFilters(this.allProducts);
        return this.sortProducts(filteredProducts);
    }

    getPaginatedProducts() {
        const sortedProducts = this.getFilteredAndSortedProducts();
        console.log("Sort/Filter active. Total items:", sortedProducts.length, "Current Page:", this.currentPage);
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return sortedProducts.slice(start, end);
    }

    getTotalPages() {
        const sortedProducts = this.getFilteredAndSortedProducts();
        return Math.ceil(sortedProducts.length / this.itemsPerPage);
    }

    hasNextPage() {
        return this.currentPage < this.getTotalPages();
    }

    hasPreviousPage() {
        return this.currentPage > 1;
    }

    async render() {
        this.loading = true;
        this.renderLoading("Updating products...");

        const productGrid = document.getElementById("product-grid");
        if (productGrid) productGrid.classList.add("loading");
        const paginatedProducts = this.getPaginatedProducts();
        if (paginatedProducts.length === 0) {
            if (productGrid) {
                productGrid.innerHTML = `<div class="title-wrapper center">
              <h2 class="title title--primary">
                No products found.
              </h2>
            </div>`;
            }
            this.renderSelectedFilters();
            this.renderFilters();
            this.renderMobileFilters();
            this.renderSort();
            this.renderPagination();
        } else {
            await new Promise((resolve) => setTimeout(resolve, 300));

            this.renderSelectedFilters();
            this.renderFilters();
            this.renderMobileFilters();
            this.renderSort();
            await this.renderProducts();
            this.renderSwiperProduct();
            this.renderPagination();
        }
        this.loading = false;
        this.renderLoading("Finished updating products");
        if (productGrid) productGrid.classList.remove("loading");

        this.renderAddToCartButtonStatus();
    }

    renderSelectedFilters() {
        const selectedFiltersEl = document.getElementById("selected-filters");
        if (!selectedFiltersEl) return;
        const selectedFilters = Object.entries(this.filters).flatMap(
            ([type, gids]) =>
                gids
                    .map((gid) => {
                        const filterOption = this.availableFilters[type]?.find(
                            (v) => v.id === gid
                        );
                        return filterOption
                            ? {
                                type,
                                typeLabel: this.filterTypes.find((f) => f.key === type)?.label,
                                gid,
                                name: filterOption.name,
                            }
                            : null;
                    })
                    .filter(Boolean)
        );

        selectedFiltersEl.innerHTML =
            selectedFilters.length > 0
                ? `
        ${selectedFilters
                    .map(
                        (filter) => `
          <facet-remove>
            <button type="button" class="clear-filter active-facets__button active-facets__button--light" data-filter="${filter.type}:${filter.gid}">
              <span class="active-facets__button-inner button button--tertiary">
                ${filter.typeLabel}: ${filter.name}
                <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span class="visually-hidden">Remove filter</span>
              </span>
            </button>
          </facet-remove>
        `
                    )
                    .join("")}
        <button id="clear-all-filters" class="text-blue-500 hover:underline">Clear All</button>
      `
                : "";
    }

    renderFilters() {
        const filterSection = document.getElementById("filter-section");
        if (!filterSection) return;

        filterSection.innerHTML = this.filterTypes
            .map(
                (type) => `
      <details class="facets__disclosure-vertical js-filter" data-index="1" id="filter-${type.label.replace(/\s+/g, "-").toLowerCase()}" ${this.defaultOpenFilter === ("filter-" + type.label.replace(/\s+/g, "-").toLowerCase()) ? "open" : ""}>
        <summary class="facets__summary caption-large focus-offset" aria-label="${type.label}">
          <div>
            <span class="facets__summary-label">${type.label}</span>
            <svg class="icon icon-caret" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clip-path="url(#clip0_17_351)">
                <path d="M10 3.125V16.875" stroke="#343333" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M15.625 11.25L10 16.875L4.375 11.25" stroke="#343333" stroke-linecap="round" stroke-linejoin="round"></path>
              </g>
              <defs>
                <clipPath id="clip0_17_351">
                  <rect width="20" height="20" fill="white" transform="matrix(0 1 -1 0 20 0)"></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
        </summary>
        <div class="parent-display facets__display-vertical">
          <fieldset class="facets-wrap parent-wrap facets-wrap-vertical">
            <legend class="visually-hidden">${type.label}</legend>
            <ul class="facets-layout facets-layout-list facets-layout-list--text facets__list--vertical list-unstyled" role="list">
              ${(this.availableFilters[type.key] || [])
                        .map((option, index) => {
                            const liClass = index > 8 ? "show-more-item hidden" : "";
                            return `
                  <li class="list-menu__item facets__item ${liClass}">
                    <label class="facets__label facet-checkbox ${this.filters[type.key].includes(option.id) ? "active" : ""}">
                      <input
                        type="checkbox"
                        name="${type.key}"
                        value="${option.id}"
                        ${this.filters[type.key].includes(option.id) ? "checked" : ""}
                        class="mr-2"
                      />
                      <svg class="icon icon_frame" width="28px" height="28px" viewBox="0 0 28 28" aria-hidden="true" focusable="false">
                        <rect width="28" height="28" stroke="currentColor" fill="none" stroke-width="1"></rect>
                      </svg>
                      <svg aria-hidden="true" class="icon icon-checkmark" width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5857 1.10178C13.6381 1.15403 13.6797 1.2161 13.708 1.28444C13.7364 1.35278 13.751 1.42604 13.751 1.50003C13.751 1.57402 13.7364 1.64728 13.708 1.71562C13.6797 1.78396 13.6381 1.84603 13.5857 1.89828L5.71073 9.77328C5.65848 9.82566 5.5964 9.86722 5.52807 9.89558C5.45973 9.92394 5.38647 9.93853 5.31248 9.93853C5.23849 9.93853 5.16523 9.92394 5.09689 9.89558C5.02855 9.86722 4.96648 9.82566 4.91423 9.77328L0.976728 5.83578C0.871106 5.73016 0.811768 5.5869 0.811768 5.43753C0.811768 5.28816 0.871106 5.1449 0.976728 5.03928C1.08235 4.93366 1.22561 4.87432 1.37498 4.87432C1.52435 4.87432 1.66761 4.93366 1.77323 5.03928L5.31248 8.57965L12.7892 1.10178C12.8415 1.0494 12.9036 1.00783 12.9719 0.979477C13.0402 0.95112 13.1135 0.936523 13.1875 0.936523C13.2615 0.936523 13.3347 0.95112 13.4031 0.979477C13.4714 1.00783 13.5335 1.0494 13.5857 1.10178Z" fill="white"></path>
                      </svg>
                      <span class="facet-checkbox__text" aria-hidden="true">
                        <span class="facet-checkbox__text-label">${option.name}</span>
                      </span>
                    </label>
                  </li>
                `;
                        })
                        .join("")}
            </ul>
          </fieldset>
          ${this.availableFilters[type.key]?.length > 8
                        ? `
            <show-more-button id="Show-More-${type.key}">
              <button class="button-show-more link underlined-link" type="button">
                <span class="label-show-more label-text"><span aria-hidden="true">+ </span>Show more</span>
                <span class="label-show-less label-text hidden"><span aria-hidden="true">- </span>Show less</span>
              </button>
            </show-more-button>
          `
                        : ""
                    }
        </div>
      </details>
    `
            )
            .join("");
    }

    renderMobileFilters() {
        const filterSection = document.getElementById("FacetsWrapperMobile");
        if (!filterSection) return;

        let mobilefilter = this.filterTypes
            .map((type) => {
                if (this.availableFilters[type.key]?.length > 0) {
                    return `
      <details class="mobile-facets__details js-filter" data-index="1">
        <summary class="mobile-facets__summary focus-inset" aria-label="${type.label}">
          <div>
            <span class="facets__summary-label">${type.label}</span>
           <span class="mobile-facets__arrow">
            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
            </svg>
          </span>
          </div>
        </summary>
        <div class="mobile-facets__submenu gradient">
        <button class="mobile-facets__close-button link link--text focus-inset" aria-expanded="true" type="button">
                            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
</svg><span>${type.label}</span></button>
        
            <ul class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled" role="list">
              ${this.availableFilters[type.key]
                            .map((option) => {
                                return `
                  <li class="mobile-facets__item list-menu__item ">
                    <label class=" facets__label facet-checkbox ${this.filters[type.key].includes(option.id) ? "active" : ""}">
                      <input
                        type="checkbox"
                        name="${type.key}"
                        value="${option.id}"
                        ${this.filters[type.key].includes(option.id) ? "checked" : ""}
                        class="mr-2"
                      />
                      <svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16" aria-hidden="true" focusable="false" >
                                        <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
                      </svg>
                      <svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                        <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span class="facet-checkbox__text" aria-hidden="true">
                        <span class="facet-checkbox__text-label">${option.name}</span>
                      </span>
                    </label>
                  </li>
                `;
                            })
                            .join("")}
            </ul>
        </div>
      </details>
    `;
                }
            })
            .join("");

        mobilefilter += `<div class="mobile-facets__details js-filter large-up-hide" data-index="mobile-">
                  <div class="mobile-facets__summary">
                    <div class="mobile-facets__sort">
                      <label for="SortBy-mobile">Sort By:</label>
                      <div class="select">
       <select id="sort-select-mobile" class="facet-filters__sort select__select caption-large">
        <option value="new" ${this.sortOption === "new" ? "selected" : ""}>New</option>
        <option value="featured" ${this.sortOption === "featured" ? "selected" : ""}>Featured</option>
        <option value="best-sellers" ${this.sortOption === "best-sellers" ? "selected" : ""}>Best Sellers</option>
        <option value="manual" ${this.sortOption === "manual" ? "selected" : ""}>Popularity</option>
        <option value="title-asc" ${this.sortOption === "title-asc" ? "selected" : ""}>Alphabetically, A-Z</option>
        <option value="title-desc" ${this.sortOption === "title-desc" ? "selected" : ""}>Alphabetically, Z-A</option>
      </select>
      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
</svg>
      </div>
                    </div>
                  </div>
                </div>`;
        filterSection.innerHTML = mobilefilter;
        // <option value="price-asc" ${this.sortOption === "price-asc" ? "selected" : ""}>Price, low to high</option>
        // <option value="price-desc" ${this.sortOption === "price-desc" ? "selected" : ""}>Price, high to low</option>
    }

    renderSort() {
        const sortSection = document.getElementById("sort-section");
        if (!sortSection) return;
        sortSection.innerHTML = `
      <select id="sort-select" class="facet-filters__sort select__select caption-large">
        <option value="new" ${this.sortOption === "new" ? "selected" : ""}>New</option>
        <option value="featured" ${this.sortOption === "featured" ? "selected" : ""}>Featured</option>
        <option value="best-sellers" ${this.sortOption === "best-sellers" ? "selected" : ""}>Best Sellers</option>
        <option value="manual" ${this.sortOption === "manual" ? "selected" : ""}>Popularity</option>
        <option value="title-asc" ${this.sortOption === "title-asc" ? "selected" : ""}>Alphabetically, A-Z</option>
        <option value="title-desc" ${this.sortOption === "title-desc" ? "selected" : ""}>Alphabetically, Z-A</option>
      </select>
    `;
        // <option value="price-asc" ${this.sortOption === "price-asc" ? "selected" : ""}>Price, low to high</option>
        // <option value="price-desc" ${this.sortOption === "price-desc" ? "selected" : ""}>Price, high to low</option>
        if (document.querySelector(".facet-filters")) {
            document.querySelector(".facet-filters").classList.remove("d-none");
        }
    }

    async renderProducts() {
        const productGrid = document.getElementById("product-grid");
        if (!productGrid) return;
        const paginatedProducts = this.getPaginatedProducts();
        let swatchCounter = 0;
        productGrid.innerHTML =
            paginatedProducts.length > 0
                ? paginatedProducts
                    .map((product, productIndex) => {
                        if (!product) return "";
                        const rawBpCode = (product.backplate_code || product.rosset_code || "").replace(/^-+/, "").toUpperCase();
                        const bpCode = /^R\d$/.test(rawBpCode) ? rawBpCode + "0" : rawBpCode;

                        const swatchesFiltered = (product.category_swatches || [])
                            .filter((s) => s && s.sku && s.sku.trim() !== "")
                            .map((s) => {
                                let matchedSku = s.sku;
                                let matchedImageUrl = s.image_url;
                                try {
                                    const bpSegmentMatch = s.sku.match(/-(R\d+)-/i);
                                    const skuBpSegment = bpSegmentMatch ? bpSegmentMatch[1].toUpperCase() : null;

                                    if (skuBpSegment && bpCode && bpCode.toUpperCase() !== skuBpSegment) {
                                        const escapedSegment = skuBpSegment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                        const segmentRegex = new RegExp(`-${escapedSegment}-`, 'i');
                                        matchedSku = s.sku.replace(segmentRegex, `-${bpCode}-`);
                                        if (matchedImageUrl && segmentRegex.test(matchedImageUrl)) {
                                            matchedImageUrl = matchedImageUrl.replace(segmentRegex, `-${bpCode}-`);
                                        }
                                    }
                                } catch (e) { }

                                let matchedVariantId = s.variant_id;
                                let matchedVariantPrice = s.variant_price;
                                if (product.variants && product.variants.length > 0) {
                                    const normalizedSku = matchedSku.replace(/[\/\s+]/g, "").toLowerCase().trim();
                                    const foundVariant = product.variants.find((v) => {
                                        const vSku = v && v.sku ? v.sku.replace(/[\/\s+]/g, "").toLowerCase().trim() : "";
                                        return vSku === normalizedSku;
                                    });
                                    if (foundVariant) {
                                        matchedVariantId = foundVariant.id;
                                        if (foundVariant.price) {
                                            matchedVariantPrice = foundVariant.price.amount || foundVariant.price;
                                        }
                                    } else if (!matchedVariantId) {
                                        matchedVariantId = "";
                                    }
                                }

                                return {
                                    ...s,
                                    sku: matchedSku,
                                    image_url: matchedImageUrl,
                                    variant_id: matchedVariantId,
                                    variant_price: matchedVariantPrice
                                };
                            })
                            .filter(Boolean);

                        let displayAmount = product.price?.minVariantPrice?.amount || "0.00";
                        if (parseFloat(displayAmount) <= 0) {
                            const swatchPrices = swatchesFiltered
                                .map((s) => parseFloat(s.variant_price))
                                .filter((p) => !isNaN(p) && p > 0);
                            if (swatchPrices.length) {
                                displayAmount = Math.min(...swatchPrices).toFixed(2);
                            } else {
                                const variantPrices = (product.variants || [])
                                    .map((v) => parseFloat(v.price?.amount || v.price))
                                    .filter((p) => !isNaN(p) && p > 0);
                                if (variantPrices.length) {
                                    displayAmount = Math.min(...variantPrices).toFixed(2);
                                }
                            }
                        }
                        const compareAmount = product.compareAtPriceRange?.minVariantPrice?.amount || "0.00";
                        const currencyCode = product.price?.minVariantPrice?.currencyCode || "AUD";
                        const onsaleClass = parseFloat(compareAmount) > parseFloat(displayAmount) ? "price--on-sale" : "";
                        const secondVariant = product?.variants?.[1] || null;

                        let Doesfinish = 0;
                        if (swatchesFiltered.length > 0 && this.filters?.finish?.length > 0) {
                            const filterFinish = this.filters.finish[0];
                            const foundIndex = swatchesFiltered.slice(0, 6).findIndex((finish) =>
                                finish && finish.name && finish.name.replace(/ /g, "-").replace(/\(/g, "").replace(/\)/g, "").toLowerCase() === filterFinish
                            );
                            if (foundIndex !== -1) {
                                Doesfinish = foundIndex;
                            }
                        }
                        const activeSku = swatchesFiltered.length > 0 ? swatchesFiltered[Doesfinish].sku : "";
                        return `
            <li class="grid__item">
              <div class="card_product_block main_product_grid_block" data-product-handle="${product.handle}" data-placeholder-image="${this.PLACEHOLDER_IMAGE}" data-backplate-code="${bpCode}" data-featured-image="${this.formatImageUrl(product.product_media || product.images?.[0] || this.PLACEHOLDER_IMAGE, 600)}">
                <div class="card_product_block_img_slider swiper ratio ratio-1x1">
                  <a href="${window.Shopify?.routes?.root}products/${product.handle}${activeSku ? `?sku=${activeSku}` : ""}" class="swiper-wrapper update_url">
                    ${swatchesFiltered.length > 0
                                ? swatchesFiltered
                                    .slice(0, 6)
                                    .map((finish, index) => `
                              <div class="swiper-slide" data-index="${index}" data-slide-index="${index}" data-media-id="${(finish.sku || '').replace(/[\/\s+]/g, '')}">
                                <img
                                  src="${this.formatImageUrl(finish.image_url || product.product_media || (product.images?.length > 0 ? product.images[0] : this.PLACEHOLDER_IMAGE), 600)}"
                                  alt="${product.title}"
                                  class="w-100"
                                  onerror="this.onerror=null; this.src='${this.PLACEHOLDER_IMAGE}';"
                                />
                              </div>
                            `).join("") + `
                              <div class="swiper-slide swiper-slide-fallback d-none" data-index="fallback" data-slide-index="fallback" data-media-id="fallback">
                                <img
                                  src="${this.formatImageUrl(product.images?.length > 0 ? product.images[0] : this.PLACEHOLDER_IMAGE, 600)}"
                                  alt="${product.title}"
                                  class="w-100"
                                  onerror="this.onerror=null; this.src='${this.PLACEHOLDER_IMAGE}';"
                                />
                              </div>
                            `
                                : product.product_media
                                    ? `
                              <div class="swiper-slide" data-index="0" data-slide-index="0">
                                <img src="${this.formatImageUrl(product.product_media, 600)}" alt="${product.title}" class="w-100" onerror="this.onerror=null; this.src='${this.PLACEHOLDER_IMAGE}&width=600';" />
                              </div>
                            `
                                    : product.images?.length > 0
                                        ? `
                              <div class="swiper-slide" data-index="0" data-slide-index="0">
                                <img src="${this.formatImageUrl(product.images[0], 600)}" alt="${product.title}" class="w-100" onerror="this.onerror=null; this.src='${this.PLACEHOLDER_IMAGE}&width=600';" />
                              </div>
                            `
                                        : `<div class="swiper-slide" data-index="0" data-slide-index="0">
                               <img src="${this.PLACEHOLDER_IMAGE}&width=300" alt="${product.title}" class="w-100" />
                             </div>`
                            }
                  </a>
                  ${swatchesFiltered.length > 1
                                ? `
                        <div class="swiper-button-next card_product_block_img_slider_next"></div>
                        <div class="swiper-button-prev card_product_block_img_slider_prev"></div>
                      `
                                : ""
                            }
                </div>
                <div class="card_product_block_content">
                  <div class="card_product_block_title">
                    <a class="text-inherit update_url" href="${window.Shopify?.routes?.root}products/${product.handle}${activeSku ? `?sku=${activeSku}` : ""}">
                      <h3 class="title">${product.title}</h3>
                      <h5 class="subtitle">${product.backplate_name || ""}</h5>
                    </a>
                  </div>
                  <div class="cl_right_block d-flex flex-column">
                    ${swatchesFiltered.length > 0 ? `
                      <div class="card_product_block_swatch">
                        ${swatchesFiltered
                                    .slice(0, 6)
                                    .map((finish, index) => {
                                        const finishId = (finish.id || finish.sku || index).toString().split("/").pop();
                                        const swatchBackground = finish.color_code || "#ffffff";
                                        const titleText = finish.name || "Finish Option";
                                        const finishCode = finish.code || "";
                                        const isFirst = index === Doesfinish ? "checked" : "";
                                        const swatchUniqueId = `swatch-${productIndex}-${index}-${swatchCounter++}`;
                                        const swatchName = `finish-${productIndex}-${this.makeHndle(product.id.toString())}-${this.makeHndle(product.handle)}`;

                                        return `
                              <div class="swatch_grp d-flex align-items-center">
                                <input
                                  type="radio"
                                  id="${swatchUniqueId}"
                                  name="${swatchName}"
                                  value="${finishCode}"
                                  class="swatch-input__input"
                                  ${isFirst}
                                  data-index="${index}"
                                  data-variant-id="${finish.variant_id || ""}"
                                  data-variant-price="${finish.variant_price || ""}"
                                  data-variant-image="${finish.image_url || ""}"
                                  data-variant-title="${product.title} - ${titleText}"
                                  data-variant-url="${window.Shopify?.routes?.root}products/${finish.product_handle || product.handle}?variant=${finish.variant_id || ""}"
                                  data-sku="${finish.sku || ""}"
                                  title="${titleText}"
                                />
                                <label
                                  for="${swatchUniqueId}"
                                  class="swatch-input__label"
                                  title="${titleText}"
                                >
                                  <span class="swatch" style="background-color: ${swatchBackground};"></span>
                                </label>
                              </div>
                            `;
                                    })
                                    .join("")
                                }
                        
                            <a href="${window.Shopify?.routes?.root}products/${product.handle}"  class="swatch_grp_expand d-flex align-items-center">
                              <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.10634 6.82751V4.17551H0.490344V3.46751H3.10634V0.815514H3.89834V3.46751H6.51434V4.17551H3.89834V6.82751H3.10634Z" fill="#7E7E7E"></path>
                              </svg>
                            </a>
                          
                      </div>
                    ` : ""}
                  </div>
                </div>
                <div class="card_bottom_block">
                  ${parseFloat(displayAmount) > 0 ? `
                  <div class="sp_price_wrapper d-flex align-items-sm-end align-items-start">
                    <div class="price ${onsaleClass} price--large price--show-badge">
                      <div class="price__container">
                        <div class="price__regular">
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          <span class="price-item price-item--regular">${this.CURRENCY_SYMBOL}${displayAmount} ${currencyCode}</span>
                        </div>
                        <div class="price__sale">
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          <span>
                            <s class="price-item price-item--regular">${this.CURRENCY_SYMBOL}${compareAmount} ${currencyCode}</s>
                          </span>
                          <span class="visually-hidden visually-hidden--inline">Sale price</span>
                          <span class="price-item price-item--sale price-item--last">${this.CURRENCY_SYMBOL}${displayAmount} ${currencyCode}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  ` : ""}

                  ${window.Shopify?.country !== "US"
                                ? `
                  <div class="d-flex align-items-end buy_quantity_btns">
                    <div>
                      <div class="product-form__buttons">
                        <button
                          type="button"
                          data-product_code="${product.product_code || ""}"
                          data-backplate="${bpCode ? `-${bpCode}` : ""}"
                          data-second_variant="${secondVariant?.code || ""}"
                          class="product-form__submit button button--full-width button--primary CustomAddToCartButton"
                          disabled
                        >
                          <span>Checking...</span>
                        </button>
                      </div>
                    </div>
                    <div id="Quantity-Form-${product.id}-${product.backplate_id || "default"}" class="product-form__input product-form__quantity">
                      <label class="quantity__label form__label d-none" for="Quantity-${product.id}-${product.backplate_id || "default"}">
                        Quantity
                        <span class="quantity__rules-cart hidden">
                          <div class="loading__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" width="18px" height="18px" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                          <span>(<span class="quantity-cart">0</span> in cart)</span>
                        </span>
                      </label>
                      <div class="price-per-item__container">
                        <quantity-input class="quantity" data-url="${window.Shopify?.routes?.root}products/${product.handle}">
                          <button class="quantity__button disabled" name="minus" type="button">
                            <span class="visually-hidden">Decrease quantity for ${product.title}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="2" viewBox="0 0 5 2" fill="none">
                              <path d="M0.84 1.556V0.744H4.34V1.556H0.84Z" fill="black"></path>
                            </svg>
                          </button>
                          <input
                            class="quantity__input"
                            type="number"
                            name="quantity"
                            id="Quantity-${product.id}-${product.backplate_id || "default"}"
                            data-cart-quantity="0"
                            data-min="1"
                            min="1"
                            step="1"
                            value="1"
                            form="product-form-${product.id}-${product.backplate_id || "default"}"
                          />
                          <button class="quantity__button" name="plus" type="button">
                            <span class="visually-hidden">Increase quantity for ${product.title}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                              <path d="M3.836 0.958H4.578V4.108H7.728V4.85H4.578V8H3.836V4.85H0.686V4.108H3.836V0.958Z" fill="black"></path>
                            </svg>
                          </button>
                        </quantity-input>
                      </div>
                      <div class="quantity__rules caption" id="Quantity-Rules-${product.id}-${product.backplate_id || "default"}"></div>
                    </div>
                  </div>`
                                : ` <div class="product-form__buttons d-none">
                        <span
                          data-product_code="${product.product_code || ""}"
                          data-backplate="${product.rosset_code || ""}"
                          data-second_variant="${secondVariant?.code || ""}"
                          class="product-form__submit button button--full-width button--primary CustomAddToCartButton"
                          disabled
                        >
                          <span>Checking...</span>
                        </span>
                      </div>`
                            }
                </div>
              </div>
            </li>
          `;
                    })
                    .join("")
                : "<p>No products match the selected filters.</p>";
    }

    async renderAddToCartButtonStatus() {
        const productGrid = document.getElementById("product-grid");
        if (!productGrid) return;
        const productCards = productGrid.querySelectorAll(".card_product_block");
        const updates = Array.from(productCards).map(productCard => {
            const checkedInput = productCard.querySelector(".swatch-input__input:checked");
            if (!checkedInput) {
                const firstInput = productCard.querySelector(".swatch-input__input");
                if (firstInput) {
                    firstInput.checked = true;
                }
            }
            const addToCartButton = productCard.querySelector(".CustomAddToCartButton");
            return this.updateAddToCartButtonState(productCard, addToCartButton);
        });
        await Promise.all(updates);
    }

    renderSwiperProduct() {
        if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.initCardSliders === 'function') {
            FacetFiltersForm.initCardSliders();
            return;
        }

        const gridContainer = document.getElementById('product-grid') || document;
        gridContainer.querySelectorAll(".card_product_block_img_slider").forEach((sliderEl) => {
            if (sliderEl.swiper) {
                sliderEl.swiper.destroy(true, true);
            }

            const parentCard = sliderEl.closest('.card_product_block');
            if (!parentCard) return;

            const swiper = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: parentCard.querySelector('.card_product_block_img_slider_next'),
                    prevEl: parentCard.querySelector('.card_product_block_img_slider_prev'),
                },
                on: {
                    slideChange: function () {
                        const activeIndex = this.activeIndex;
                        const radios = parentCard.querySelectorAll('.swatch-input__input');
                        const radio = radios[activeIndex];
                        if (radio) {
                            radio.checked = true;
                            radio.dispatchEvent(new Event('change', { bubbles: true }));
                            if (typeof window.updateWishlistAttributes === 'function') {
                                window.updateWishlistAttributes(parentCard, radio);
                            }
                        }
                    }
                }
            });

            parentCard.querySelectorAll('.swatch-input__input').forEach(radio => {
                radio.onclick = (event) => {
                    const targetIndex = event.target.getAttribute('data-index');
                    if (swiper && targetIndex !== null) {
                        swiper.slideTo(parseInt(targetIndex));
                    }
                };
            });
        });
    }

    renderPagination() {
        const pagination = document.getElementById("pagination");
        if (!pagination) return;
        const totalPages = this.getTotalPages();
        const maxButtons = 5;
        let startPage = Math.max(1, this.currentPage - Math.floor(maxButtons / 2));
        let endPage = Math.min(totalPages, startPage + maxButtons - 1);

        if (endPage - startPage + 1 < maxButtons) {
            startPage = Math.max(1, endPage - maxButtons + 1);
        }

        const pageButtons = Array.from(
            { length: endPage - startPage + 1 },
            (_, i) => startPage + i
        )
            .map(
                (page) => {
                    if (totalPages > 1) {
                        return `
        <li>
          <button
            data-page="${page}"
            class="px-4 py-2 rounded ${page === this.currentPage
                                ? "pagination__item link pagination__item--current"
                                : "pagination__item link"
                            }"
          >
            ${page}
          </button>
        </li>
      ` }
                })
            .join("");

        if (totalPages <= 1) {
            pagination.innerHTML = "";
            return;
        }

        pagination.innerHTML = `
      <li>
        <button
          data-page="prev"
          class="px-4 py-2 rounded ${this.hasPreviousPage()
                ? "pagination__item link"
                : "pagination__item link cursor-not-allowed d-none"
            }"
          ${!this.hasPreviousPage() ? "disabled" : ""}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M13.695 3.49514C13.5818 3.23342 13.2849 3.08498 12.9802 3.14358C12.8474 3.16701 12.4685 3.5342 9.56224 6.43654C6.65989 9.34279 6.2927 9.7217 6.26927 9.85451C6.19895 10.2217 6.01145 10.0069 9.56224 13.5615C13.113 17.1123 12.9021 16.9248 13.2693 16.8545C13.4607 16.8194 13.695 16.585 13.7302 16.3936C13.8005 16.0264 13.9607 16.2139 10.7302 12.9756L7.75364 9.99904L10.7107 7.03811C12.3669 5.38186 13.6872 4.0342 13.7107 3.9717C13.7654 3.82326 13.7575 3.63967 13.695 3.49514Z" fill="black"></path>
              </svg>
        </button>
      </li>
      ${pageButtons}
      <li>
        <button
          data-page="next"
          class="px-4 py-2 rounded ${this.hasNextPage()
                ? "pagination__item link"
                : "pagination__item link cursor-not-allowed  d-none"
            }"
          ${!this.hasNextPage() ? "disabled" : ""}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M6.30495 16.5049C6.41823 16.7666 6.71511 16.915 7.01979 16.8564C7.15261 16.833 7.53151 16.4658 10.4378 13.5635C13.3401 10.6572 13.7073 10.2783 13.7307 10.1455C13.801 9.7783 13.9885 9.99314 10.4378 6.43846C6.88698 2.88767 7.09792 3.07517 6.73073 3.14549C6.53933 3.18064 6.30495 3.41502 6.26979 3.60642C6.19948 3.97361 6.03933 3.78611 9.26979 7.02439L12.2464 10.001L9.28933 12.9619C7.63308 14.6181 6.31276 15.9658 6.28933 16.0283C6.23464 16.1767 6.24245 16.3603 6.30495 16.5049Z" fill="black"></path>
              </svg>
        </button>
      </li>
    `;
    }

    renderLoading(text) {
        const loadingEl = document.getElementById("loading");
        if (loadingEl) loadingEl.classList.toggle("loading", this.loading);
    }

    renderError() {
        const errorEl = document.getElementById("error");
        if (!errorEl) return;
        if (this.error) {
            errorEl.textContent = this.error;
            errorEl.classList.remove("hidden");
        } else {
            errorEl.classList.add("hidden");
        }
    }
}

const productListing = new ProductListing();